import { cardShape } from '@editor/droplets/utils';

export default function cardsWide() {
  return {
    _id: false,
    type: 'droplet.cardsWide',
    cards: [
      cardShape({ type: 'droplet.cardsWide.cardItem' })(),
      cardShape({ type: 'droplet.cardsWide.cardItem' })(),
    ],
    mediaQueries: [
      {
        selector: '.drzCard-wide-text',
        properties: [
          {
            property: 'background-color',
            desktop: 'rgba(255, 255, 255, 1)',
            tablet: 'default',
            mobile: 'default',
          },
        ],
      },
    ],
    pageCSS: '',
    bounceDroplet: false,
    firstDrop: false,
    activeCard: null,
    isShared: false,
    templateRegion: false,
  };
}



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/cards-wide/droplet.schema.js